
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';

export default defineComponent({
  name: 'MigrationCallout',

  components: { SpmButton },

  emits: ['migrate'],

  setup() {
    const { t } = useI18n();
    return { t };
  },
});
